import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class LegacyRoutesGuard {
  public constructor(protected router: Router) {}

  protected async canActivateInternal() {
    return await this.router.navigate([`app${window.location.hash.replace('#', '')}`]);
  }

  public async canActivate() {
    return await this.canActivateInternal();
  }

  public async canActivateChild() {
    return await this.canActivate();
  }

  public async canMatch() {
    return await this.canActivateInternal();
  }
}
